import ITrip from 'model/ITrip';

import { CombinedActionTypes } from '../../actionsFactory';

export interface State {
  loading: boolean;
  error?: any;
  data: string[];
  meta?: {
    totalPages: number;
    pageSize: number;
    totalHits: number;
    page: number;
  };
}

export const initState: State = {
  loading: false,
  error: null,
  data: [],
  meta: null,
};

const appendOrReplace = (
  currentBookings: string[],
  newBookings: ITrip[],
): string[] => [
  ...currentBookings,
  ...newBookings
    .filter((booking) => !currentBookings.includes(booking.id))
    .map(({ id }) => id),
];

const reducer = (state: State, action: CombinedActionTypes): State => {
  switch (action.type) {
    case 'ARCHIVED_BOOKINGS:FETCHING':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'ARCHIVED_BOOKINGS:FETCHING_SUCCESS':
      return {
        ...state,
        data: appendOrReplace(state.data, action.payload.result.data),
        meta: {
          page: parseInt(action.payload.result.meta.page, 10),
          pageSize: parseInt(action.payload.result.meta.pageSize, 10),
          totalHits: parseInt(action.payload.result.meta.totalHits, 10),
          totalPages: parseInt(action.payload.result.meta.totalPages, 10),
        },
        loading: false,
        error: null,
      };
    case 'ARCHIVED_BOOKINGS:FETCHING_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
